module.exports = __webpack_public_path__ + "images/chevron-right-white.svg";